import { ShieldCheck, Lock, EyeOff } from "lucide-react";

const POINTS = [
  {
    Icon: ShieldCheck,
    title: "HIPAA-mindful by design",
    body: "Built around the privacy principles physios already follow. Patient names never appear in list views — only initials and IDs.",
  },
  {
    Icon: Lock,
    title: "Encrypted in transit and at rest",
    body: "Everything you save flows over TLS and is stored encrypted. Your patients' history stays your patients' history.",
  },
  {
    Icon: EyeOff,
    title: "Your transcripts, your data",
    body: "We never sell or share session data. Recordings stay in-browser. AI processing is scoped tightly to extraction.",
  },
];

export default function Trust() {
  return (
    <section
      className="bg-[#F0FDF4] py-20 md:py-32 relative overflow-hidden"
      data-testid="trust-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1">
          <span className="font-figtree text-xs uppercase tracking-[0.22em] font-semibold text-[#059669]">
            Trust & privacy
          </span>
          <h2 className="mt-3 font-outfit text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#0F172A] leading-[1.1]">
            Quietly serious about protecting your patients.
          </h2>
          <p className="mt-5 font-figtree text-base sm:text-lg text-[#475569] leading-relaxed max-w-xl">
            Documentation tools live in one of the most sensitive corners of
            healthcare. We treat it that way.
          </p>

          <ul className="mt-10 space-y-5">
            {POINTS.map(({ Icon, title, body }) => (
              <li key={title} className="flex gap-4">
                <span className="flex-shrink-0 inline-flex items-center justify-center w-11 h-11 rounded-2xl bg-white text-[#059669] border border-[#D1FAE5] shadow-soft">
                  <Icon className="w-5 h-5" />
                </span>
                <div>
                  <div className="font-outfit text-lg font-semibold text-[#0F172A]">
                    {title}
                  </div>
                  <div className="mt-1 font-figtree text-sm md:text-base text-[#475569] leading-relaxed">
                    {body}
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-6 order-1 lg:order-2">
          <div className="relative rounded-3xl overflow-hidden shadow-[0_30px_60px_rgba(6,78,59,0.18)] border border-white">
            <img
              src="https://images.unsplash.com/photo-1706353399656-210cca727a33?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwzfHxwaHlzaW90aGVyYXBpc3QlMjBjbGluaWMlMjBwYXRpZW50fGVufDB8fHx8MTc3OTU1MzE1MXww&ixlib=rb-4.1.0&q=85"
              alt="Physiotherapist working closely with a patient"
              className="w-full h-[420px] md:h-[520px] object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
